import React from 'react';
import Icon from '../../../components/AppIcon';

const ProcessSteps = () => {
  const steps = [
    {
      number: '1',
      icon: 'Users',
      title: 'Partner finden',
      description: 'Wenden Sie sich an einen unserer Partner in Ihrer Nähe.'
    },
    {
      number: '2',
      icon: 'FileText',
      title: 'Daten übermitteln',
      description: 'Geben Sie Ihre Fahrzeugdaten und den Fahrzeugschein beim Partner ab.'
    },
    {
      number: '3',
      icon: 'CheckCircle2',
      title: 'Wir kümmern uns um alles',
      description: 'Grid Balance prüft die Angaben und wickelt das CO₂‑Zertifikat ab.'
    },
    {
      number: '4',
      icon: 'Gift',
      title: 'Prämie erhalten',
      description: 'Nach erfolgreicher Prüfung erhalten Sie Ihre Prämie vom Partner.'
    }
  ];

  return (
    <section className="py-12 md:py-16 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground mb-4">
            So funktioniert's
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            In nur 4 einfachen Schritten zu Ihrer THG-Prämie
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps?.map((step, index) => (
            <div key={index} className="relative">
              <div className="flex flex-col items-center text-center">
                <div className="relative mb-4">
                  <div 
                    className="w-16 h-16 rounded-full flex items-center justify-center shadow-card"
                    style={{ backgroundColor: 'var(--color-primary)' }}
                  >
                    <Icon name={step?.icon} size={28} color="#ffffff" />
                  </div>
                  <div 
                    className="absolute -top-2 -right-2 w-8 h-8 rounded-full flex items-center justify-center text-white font-bold text-sm shadow-lg"
                    style={{ backgroundColor: 'var(--color-secondary)' }}
                  >
                    {step?.number}
                  </div>
                </div>
                
                <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
                  {step?.title}
                </h3>
                <p className="text-sm text-muted-foreground">
                  {step?.description}
                </p>
              </div>

              {index < steps?.length - 1 && (
                <div 
                  className="hidden lg:block absolute top-8 left-full w-full h-0.5 -translate-x-1/2"
                  style={{ backgroundColor: 'var(--color-border)' }}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSteps;